import { render, staticRenderFns } from "./telTest.vue?vue&type=template&id=1983239c&scoped=true"
import script from "./telTest.vue?vue&type=script&lang=js"
export * from "./telTest.vue?vue&type=script&lang=js"
import style0 from "./telTest.vue?vue&type=style&index=0&id=1983239c&prod&scoped=true&lang=css"
import style1 from "./telTest.vue?vue&type=style&index=1&id=1983239c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1983239c",
  null
  
)

export default component.exports